import * as React from 'react';
import { Price, Tooltip } from '@grandvisionhq/common';
import { Types } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';

const PriceTooltipContainer = ({ appliedDiscounts , id  })=>{
    const { getLabel , currency  } = useIntl();
    const cartDiscounts = appliedDiscounts === null || appliedDiscounts === void 0 ? void 0 : appliedDiscounts.filter((discount)=>discount.type === Types.DiscountProductType.CART_DISCOUNT
    ).filter((discount)=>discount.value > 0
    );
    const productDiscounts = appliedDiscounts === null || appliedDiscounts === void 0 ? void 0 : appliedDiscounts.filter((discount)=>discount.type === Types.DiscountProductType.PRODUCT_DISCOUNT
    ).filter((discount)=>discount.value > 0
    );
    const productDiscountsAggregated = {
        label: getLabel('cart.lineItem.productDiscounts'),
        value: productDiscounts.reduce((total, discount)=>{
            return total + discount.value;
        }, 0),
        type: Types.DiscountType.ProductDiscount
    };
    // Neglect product discount aggregation when there are no product discounts
    const discountsCombined = productDiscounts.length ? [
        productDiscountsAggregated,
        ...cartDiscounts
    ] : cartDiscounts;
    const discountSummary = /*#__PURE__*/ React.createElement("article", {
        className: "line-item__price-tooltip"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "line-item__price-tooltip-header"
    }, getLabel('cart.lineItem.discountsApplied'), ":"), /*#__PURE__*/ React.createElement("dl", {
        className: "line-item__price-tooltip-body"
    }, discountsCombined.map((discount)=>/*#__PURE__*/ React.createElement("div", {
            key: `${id}-${discount.label}`,
            className: "line-item__price-tooltip-discount"
        }, /*#__PURE__*/ React.createElement("dt", {
            className: "line-item__price-tooltip-term"
        }, discount.label, ":\xa0"), /*#__PURE__*/ React.createElement("dd", {
            className: "line-item__price-tooltip-value"
        }, "-", /*#__PURE__*/ React.createElement(Price, {
            value: discount.value,
            currency: currency
        })))
    )), /*#__PURE__*/ React.createElement("p", null, getLabel('cart.lineItem.discountDisclaimer')));
    return /*#__PURE__*/ React.createElement(Tooltip, {
        id: `${id}-price-tooltip`,
        message: discountSummary,
        renderInPortal: true
    });
};

export { PriceTooltipContainer };
//# sourceMappingURL=PriceTooltipContainer.js.map
